import { Typography, Tooltip, useTheme } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import TooltipComponent from "./CustomTooltip";
// Hook to detect truncation
function useIsTruncated(text: string) {
  const ref = useRef<HTMLSpanElement>(null);
  const [truncated, setTruncated] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (el) setTruncated(el.scrollWidth > el.clientWidth);
  }, [text]);

  return [ref, truncated] as const;
}

// Ellipsis with Tooltip Component
export default function TruncatedTypography({
  children,
  tooltipProps = {},
  sx = {},
  ...typographyProps
}: any) {
  const [ref, isTruncated] = useIsTruncated(children);
const theme =  useTheme();
  const content = (
    <Typography
      ref={ref}
      variant="subtitle1"
      sx={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        ...sx, // allow parent to pass color, fontWeight, padding, etc
      }}
    //   {...typographyProps}
    >
      {children}
    </Typography>
  );

  return isTruncated ? (
    <TooltipComponent title={children} {...tooltipProps} placement="right"  theme={theme}>
      {content}
    </TooltipComponent>
  ) : (
    content
  );
}